<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" text="birthDayGift" />
      </v-col>
    </v-row>

    <v-row style="margin-bottom: 160px">
      <v-col cols="12">
        <v-card elevation="0">
          <v-card-text class="py-0">
            <v-row justify="center" style="display: grid">
              <v-col cols="12" md="6">
                <v-img :src="item.image"></v-img>
              </v-col>
              <v-col cols="12">
                <p class="text-h6 text--primary mx-0 text-start mb-0">
                  {{ item.title }}
                </p>
                <p class="text-content text--primary mx-0 text-start mb-0">
                  {{ item.sub_title }}
                </p>
                <v-img
                  :src="
                    item.reward?.image_path
                      ? item.reward?.image_path
                      : require('@/assets/images/hbd.png')
                  "
                  class="mt-3"
                  max-height="300px"
                  max-width="300px"
                  contain
                >
                </v-img>

                <v-tabs
                  v-model="tab"
                  background-color="transparent"
                  color="primary"
                  fixed-tabs
                  height="56px"
                >
                  <v-tab href="#tab-1"> {{ $t("detail") }} </v-tab>
                  <v-tab href="#tab-2" v-if="item.reward_id">
                    {{ $t("termAndCondition2") }}
                  </v-tab>
                  <v-tabs-items v-model="tab" class="mt-5">
                    <v-tab-item :value="'tab-1'">
                      <div
                        class="ql-editor"
                        style="height: fit-content"
                        v-html="formatHtmlDetail(item.description)"
                      ></div>
                    </v-tab-item>
                    <v-tab-item :value="'tab-2'">
                      <div
                        class="ql-editor"
                        style="height: fit-content"
                        v-html="formatHtmlDetail(item.reward?.detail)"
                      ></div>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-col>
            </v-row>
          </v-card-text> </v-card
      ></v-col>
    </v-row>
    <v-footer fixed padless color="white">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-row class="pt-4" justify="center">
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg white--text"
                  :color="site.color"
                  @click="confirmBirthdayGift()"
                >
                  {{ $t("claimGift") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import { formatHtmlDetailDefault } from "../../../config/general-function.js";

export default {
  name: "Blog",
  components: { HeaderTextBg },
  data() {
    return {
      item: [],
      tab: "tab-1",
    };
  },
  created() {
    this.getBirthdayGift();
  },
  methods: {
    getBirthdayGift() {
      Axios.get("getBirthdayGift").then(({ data }) => {
        this.item = data.data;
        if (this.item == null || this.item == undefined) {
          this.$swal.fire({
            icon: "warning",
            text: this.$t("errDataNotFound"),
            showConfirmButton: false,
            timer: 2000,
          });
          const targetRoute = this.$router.resolve({
            name: "main",
          });
          window.location.href = targetRoute.href;
        }
      });
    },

    confirmBirthdayGift() {
      Axios.post("confirmBirthdayGift").then(({ data }) => {
        if (data.status == "success") {
          this.$swal.fire({
            icon: "success",
            text: this.$t("claimGiftSuccess"),
            showConfirmButton: false,
            timer: 2000,
          });
          const targetRoute = this.$router.resolve({
            name: "main",
          });
          window.location.href = targetRoute.href;
        }
      });
    },

    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
  },

  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {},
};
</script>

<style>
img {
  width: 100%;
  height: 100%;
}
</style>